
export const REFRESH_TIMER = 43200000;